import styled from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';
import { respondTo } from '../../styles/_respondTo';

export const ContentWrapper = styled.div`
  padding: 30px 20px 0 20px;
  width: 100%;
  flex: 1;
  display: flex;
  box-shadow: inset 0 -1px 0 0 ${colors.elements.border};
  overflow-y: auto;
  ${respondTo.mobile`
    flex-direction: column;
    box-shadow: unset;
  `}
  ${respondTo.smallDesktop`
     flex-wrap: wrap;
  `}
`;

export const Header = styled.div`
  padding: 20px 20px 10px 20px;
  position: relative;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  width: 100%;
  display: flex;
  min-height: 62px;
  //justify-content: center;

  ${respondTo.mobile`
      // box-shadow: 0 2px 2px 0 #FAE5D6;
      flex-direction: column;
      box-shadow: none;
      justify-content: flex-start;
      padding: 0 20px 0 20px;
      min-height: auto;
  `}
`;

export const HeaderTitle = styled.h3`
  position: ${({ pos = 'absolute' }) => pos};
  font-family: ${fontFamily.primary};
  font-size: 24px;
  font-weight: bold;
  color: #636262;
  left: 20px;
  bottom: 10px;

  ${respondTo.mobile`
    position: unset;
      left: 0px;
      bottom: 0;
      padding-bottom: 0;
  `}
`;
